import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { PublicHeader, PublicFooter, Loading } from "@/components/shared";
import { BranchProfileView } from "@/pages/BranchProfile";
import { ReferralResponseSection } from "@/components/ReferralResponseSection";
import { HaveABusinessHook } from "@/components/HaveABusinessHook";
import { Button } from "@/components/ui/button";

export default function ReferralLanding() {
  const { code } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/r/${code}`).then(({ data }) => setData(data)).catch(() => setData(false));
  }, [code]);

  if (data === null) return (<div className="flex min-h-screen flex-col"><PublicHeader /><Loading /><PublicFooter /></div>);
  if (data === false) return (<div className="flex min-h-screen flex-col"><PublicHeader /><p className="flex-1 p-10 text-center text-muted-foreground">This referral link is invalid.</p><PublicFooter /></div>);

  return (
    <div className="flex min-h-screen flex-col">
      <PublicHeader />
      <div className="mx-auto max-w-3xl flex-1 px-4 pt-6">
        <div className="rounded-[14px] border border-brand-green/20 bg-brand-green/5 px-5 py-3 text-brand-green" data-testid="referred-you-banner">
          <span className="inline-flex flex-wrap items-center gap-2">
            <span className="font-semibold">{data.referrer_name}</span>
            {data.referrer_trust_badge ? (
              <span className="inline-flex items-center gap-1 rounded-full bg-brand-green/15 px-2 py-0.5 text-xs font-semibold" data-testid="trust-badge">
                {data.referrer_trust_badge.label}
              </span>
            ) : null}
            <span>referred you to {data.branch.company_name}.</span>
          </span>
        </div>
      </div>
      <BranchProfileView
        branch={data.branch}
        referrerName={data.referrer_name}
        hideInactiveReward
        afterDetails={
          <>
            <HaveABusinessHook className="mt-6 text-center sm:text-left" />
            <ReferralResponseSection
              code={code}
              referrerName={data.referrer_name}
              businessName={data.branch.company_name}
              initialResponse={data.response}
            />
          </>
        }
      >
        {data.branch.reward_active ? (
          <Button
            className="mt-5 w-full bg-brand-gold text-brand-ink hover:bg-brand-gold-dark"
            onClick={() => nav(`/claim/${code}`)}
            data-testid="claim-discount-btn"
          >
            Claim my discount
          </Button>
        ) : null}
      </BranchProfileView>
      <PublicFooter />
    </div>
  );
}
